import { useCallback, useMemo } from 'react';
import {
  getRoutesFromLocalStorage,
  checkSearchHistoryFromStorage,
  saveSearchRouteInLocalStorage,
} from '@ott/search-history';

import { HOTELS_SEARCH_HISTORY_KEY, HOTELS_SEARCH_HISTORY_MAX_RECORDS } from '../constants';
import { SubmitPayload } from '../types';

interface Route {
  fromDate: Date;
  toDate: Date;
  to: string;
}

interface HistoryRecord extends SubmitPayload {
  route: Route;
}

const dateString = (date: Date) => {
  if (date instanceof Date) {
    return date.toISOString();
  }

  return String(date);
};

const serializeRoute = ({ fromDate, toDate, to }: Route) => {
  const d1 = dateString(fromDate).split('T');
  const d2 = dateString(toDate).split('T');

  return `${d1}${d2}${to}`;
};

const filterHistoryRecords = (records: HistoryRecord[], newRecord: HistoryRecord) => {
  return records.filter(
    (record) => serializeRoute(record.route) !== serializeRoute(newRecord.route)
  );
};

const useHistory = (submit: (payload: SubmitPayload) => void) => {
  const records = useMemo(() => {
    const historyRecords = getRoutesFromLocalStorage(
      HOTELS_SEARCH_HISTORY_KEY,
      HOTELS_SEARCH_HISTORY_MAX_RECORDS,
      checkSearchHistoryFromStorage
    );

    return (historyRecords || []).map((record: HistoryRecord) => {
      const { route, url, params } = record;

      return {
        /**
         * Ошибки никакой нет, просто SearchHistory очень старый
         * и много чего не учитывает
         */
        from: route.to,
        fromDate: new Date(route.fromDate),
        toDate: new Date(route.toDate),
        isRT: true,
        url,
        params,
      };
    });
  }, []);

  const saveRecord = (record: HistoryRecord) => {
    saveSearchRouteInLocalStorage(
      record,
      HOTELS_SEARCH_HISTORY_KEY,
      HOTELS_SEARCH_HISTORY_MAX_RECORDS,
      filterHistoryRecords
    );
  };

  const submitRecord = useCallback(
    (record: HistoryRecord) => {
      const { params, url } = record;

      submit({ params, url });
    },
    [submit]
  );

  return { records, saveRecord, submitRecord };
};

export default useHistory;
